export default __webpack_public_path__ + "static/media/first_img.38c2a0a6.svg";